import moment from 'moment'
import numeral from 'numeral'

export const Supplies = {
  id: '',
  name: '',
  remarks: '',
  isActive: false,
}

export const SuppliesDetail = {
  id: '',
  suppliesId: '',
  supplierId: '',
  supplierName: '',
  uomId: '',
  uomName: '',
  date: moment().format('YYYY-MM-DD'),
  qty: 0,
  price: 0,
  remarks : '',
}